// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__7P4aJ","bigColWidth":"Table_bigColWidth__3-bW6","biggerColWidth":"Table_biggerColWidth__3b9pY","row":"Table_row__30yjh","col":"Table_col__3YNxV"};